import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface RememberEmailStore {
  rememberEmail: boolean;
  rememberedEmail: string;
  setRemember: (value: boolean) => void;
  saveEmail: (email: string) => void;
  clearEmail: () => void;
  reset: () => void;
}

export const useRememberEmailStore = create<RememberEmailStore>()(
  persist(
    (set) => ({
      rememberEmail: false,
      rememberedEmail: '',
      setRemember: (value) => set({ rememberEmail: value }),
      saveEmail: (email) => set({ rememberedEmail: email, rememberEmail: true }),
      clearEmail: () => set({ rememberedEmail: '' }), // 이메일만 삭제, 체크박스 상태는 유지
      reset: () => set({ rememberedEmail: '', rememberEmail: false }), // 완전 초기화
    }),
    {
      name: 'remember-email-storage',
    }
  )
);
